<template>
  <div class="algolia-drawer-mobile critical-component-hide">
    <div class="algolia-drawer-mobile__title-wrapper container">
      <h2
        class="algolia-drawer-mobile__title"
      >
        <icon-filter />
        <span
          class="text-label-xs"
          v-text="$string('collection.filter')"
        />
      </h2>

      <button
        v-trigger-icon
        class="algolia-drawer-mobile__close"
        @click.prevent="closeOverlay('algoliaDrawerMobile')"
      >
        <animated-icon
          :transition-on-hover="true"
          transition-type="spin-90"
        >
          <template #iconOne>
            <icon-close />
          </template>

          <template #iconTwo>
            <icon-close />
          </template>
        </animated-icon>
      </button>
    </div>

    <div class="algolia-drawer-mobile__inner">
      <div class="algolia-drawer-mobile__facets-wrap">
        <template
          v-for="(attribute, index) in attributes"
          :key="`${attribute.value}-${index}`"
        >
          <ais-refinement-list
            :attribute="attribute.value"
            :sort-by="['count']"
            :limit="70"
            class="algolia-filter__facet-accordion"
          >
            <template #default="{ items, refine }">
              <algolia-facet-mobile
                :facet-attribute="attribute"
                :facets="items"
                :open="activeFacet === attribute.label"
                @choices-updated="refine"
                @facet-toggled="updateOpenFacet"
              />
            </template>
          </ais-refinement-list>
        </template>
      </div>

      <ais-current-refinements>
        <template #default="{ items }">
          <div class="algolia-drawer-mobile__chips">
            <template
              v-for="item in items"
              :key="item.attribute"
            >
              <template
                v-for="refinement in item.refinements"
                :key="[
                  refinement.attribute,
                  refinement.type,
                  refinement.value,
                  refinement.operator
                ].join(':')"
              >
                <chip
                  class="algolia-drawer-mobile__chip"
                  :text="formatTitle(refinement)"
                  @remove="item.refine(refinement)"
                />
              </template>
            </template>
          </div>
        </template>
      </ais-current-refinements>
    </div>

    <div class="algolia-drawer-mobile__button-wrap">
      <btn
        class="text-label-s algolia-drawer-mobile__view-results algolia-drawer-mobile__footer-button"
        :label="$string('collection.view_results')"
        modifiers="filled block small"
        :show-icon="true"
        @click="closeOverlay('algoliaDrawerMobile')"
      />

      <ais-clear-refinements class="algolia-drawer-mobile__clear-all-wrapper">
        <template #default="{ canRefine, refine }">
          <btn
            v-show="canRefine"
            class="text-label-s algolia-drawer-mobile__clear-all algolia-drawer-mobile__footer-button"
            :label="$string('collection.clear_all')"
            modifiers="outlined"
            :show-icon="false"
            @click="refine"
          />
        </template>
      </ais-clear-refinements>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Boost drawer mobile (algolia-drawer-mobile)
 * -----------------------------------------------------------------------------
 * Mobile slide out drawer for Boost filters.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import { AisCurrentRefinements, AisClearRefinements } from 'vue-instantsearch/vue3/es'
import { mapActions } from 'vuex'
import { AisRefinementList } from 'vue-instantsearch/vue3/es'

import AnimatedIcon from '~global/animated-icon/animated-icon'
import AlgoliaFacetMobile from '~async/algolia-drawer-mobile/algolia-facet-mobile'
import Chip from "~async/chip/chip"

import IconClose from '~icons/misc/close.svg'
import IconFilter from '~icons/misc/filter.svg'

export default {
  name: 'AlgoliaDrawerMobile',

  components: {
    AnimatedIcon,
    Chip,
    AlgoliaFacetMobile,
    IconClose,
    IconFilter,
    AisRefinementList,
    AisCurrentRefinements,
    AisClearRefinements,
  },

  data() {
    return {
      activeFacet: null,
      attributes: this.$variable('algolia.filterOptions'),
    }
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
    }),

    /**
     * Format title for keys that include tag values.
     * @param {String} refinement - Algolia refinement.
     * @returns {String}
     */
    formatTitle(refinement) {
      const { attribute, label, value } = refinement

      /**
       * Formats colour labels.
       */
      if (attribute === 'colour') {
        const valueParts = label.split('-')

        if (valueParts.length <= 2 && valueParts.length){
          return valueParts[0]
        } else if (valueParts.length > 2) {
          return `${valueParts[0]}/${valueParts[2]}`
        }
      }

      if (attribute.includes('price')) {
        return label.replace(value, `${this.$variable('store.currencySymbol')}${value}`)
      }

      return label
    },

    updateOpenFacet(label) {
      this.activeFacet = label
    },
  },
}
</script>

<style lang="scss">
@import './algolia-drawer-mobile';
</style>
